// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LSQy","content":"styles_content__1SoVx"};